export const blockIconsTravelCasinoNew = (
	<span className='material-symbols-outlined'>casino</span>
);
